import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

import { GestockService } from '../services/gestock.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

import {FormControl} from '@angular/forms';

import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

import { ViewChild, TemplateRef } from '@angular/core';


@Component({
  selector: 'app-usrcreation',
  templateUrl: './usrcreation.component.html',
  styleUrls: ['./usrcreation.component.css']
})
export class UsrcreationComponent implements OnInit {

  prenomUser = "" ;
  nomUser = "" ;
  telephoneUser = "" ;
  loginUser = "" ;

  companyName = "" ;
  sigle = "---" ;

  useral : any ;

  role : any ;

  allProfils = [] ;

  allPoints : any ;

  indexChoosenProfil : any ;
  indexChoosenPoint : any ;

  choosedPoint : any ;
  choosedProfil : any ;


  doneCreating = 0 ;

  retourClientWS  : ReponseWebService ;

  myControl = new FormControl();

  filteredPoints: Observable<any[]>;

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;


  etatreq = "" ;

  samacaabiyoonwii = "" ;

  constructor(private configServer: GestockService, public dialogRef: MatDialogRef<UsrcreationComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any ) {

  	this.useral = data.opt ;
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    let profil = sessionStorage.getItem("profil") ;
    
  }

  ngOnInit(): void {
    this.getAllProfils() ;
  }


  close(){
    this.dialogRef.close();
  }


  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.allPoints.filter(option => option.nompoint.toLowerCase().indexOf(filterValue) === 0);
  }  


  displayFn(benPoint: any): string {
    return benPoint && benPoint.nompoint ? benPoint.nompoint : '';
  }

  creerAdminAndCompany(): void {
  	/*if(this.companyName.length>2 && this.sigle.length>2 && this.prenomUser.length>2 &&  this.nomUser.length>2 &&  this.telephoneUser.length>2 &&  this.loginUser.length>2 ){
	    this.configServer.createCompanyAndAdmin(1, this.companyName, this.sigle, this.prenomUser, this.nomUser, this.telephoneUser, this.loginUser).then( (retourbi) => {
	      this.retourClientWS = retourbi ;
	      var statutrec = this.retourClientWS.statutreq ;
	      if(statutrec==1){
	        console.log("Done") ;
	        this.doneCreating = 1 ;
	      }
	      else
	        console.log("Failed") ;
	    }) ;      		
  	}*/
  }



  getAllProfils(){

    this.configServer.getAllProfils(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.allProfils = this.retourClientWS.data ; 
        this.getAllPoints();
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  getAllPoints(){

    this.configServer.getAllPoints(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.allPoints = this.retourClientWS.data ; 
        this.filteredPoints = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.nompoint),
          map(name => name ? this._filter(name) : this.allPoints.slice())
        );    
        console.log("Done FilterPoints", this.filteredPoints ) ;

      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  choosePoint(choosedPoint){
    this.choosedPoint = choosedPoint ;
    console.log(this.choosedPoint) ;
  } 

  chooseAProfil(choosedProfil){
    this.choosedProfil = choosedProfil ;
  }


  creeruser(): void {
    console.log({"samacaabiyoonwii":this.samacaabiyoonwii, "point": this.choosedPoint, "prenom": this.prenomUser, 
            "nom": this.nomUser, "telephone": this.telephoneUser, "profil": this.choosedProfil}) ;
    
    this.telephoneUser = this.telephoneUser.toString() ;

    if (this.prenomUser.length>2 &&  this.nomUser.length>2 
            && this.telephoneUser.length>2 
                && this.choosedPoint!=undefined 
                  && this.choosedProfil!=undefined ){

    let body =  {"samacaabiyoonwii":this.samacaabiyoonwii, "point": this.choosedPoint, "prenom": this.prenomUser, 
            "nom": this.nomUser, "telephone": this.telephoneUser, "profil": this.choosedProfil} ;

    console.log(body) ;

    this.openSpinnerDialog();

    this.configServer.createUserComparateur(body).then( (retourbi) => {

        this.closeSpinnerDialog() ;

        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;
        if(statutrec==1){
          this.etatreq = "successful" ;
          console.log("Done") ;
        }
        else{
          this.etatreq = "failed" ;
        }
      }) ;     
           
    }    
  }

  annuler(){
  	this.dialogRef.close() ;
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}
